// extracted by mini-css-extract-plugin
export default {"share-control":"shareStyles-module__share-control__QO7pm"};